import { servicesApi } from '@/services/api/deprecated';

// TODO: Only partial interface is implemented, for limited usage
interface JourneysWorkspace {
  environment: {
    sent_attributes: string[];
  };
}

export const getJourneysWorkspace = async (environmentId: number | string | null) => {
  if (isNaN(parseInt(String(environmentId)))) {
    return null;
  }
  const { data } = await servicesApi.get<JourneysWorkspace>(`/environments/${environmentId}`);

  return data;
};
